import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import emailjs from "emailjs-com";
import "./Contact.css";

function Contact() {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };


  const handleSubmit = (e) => {
    e.preventDefault();


    if (!formData.name || !formData.email || !formData.message) {
      setStatus("Please fill all required fields.");
      return;
    }


    const templateParams = {

      // Receiver email
      to_email: "klyzenventures@gmail.com",

      // User details
      name: formData.name,
      email: formData.email,
      mobile: formData.mobile,
      message: formData.message,


      // EmailJS default fields
      from_name: formData.name,
      from_email: formData.email,
      from_mobile: formData.mobile,

    };


    emailjs.send(
      "service_tlo4b0p",      // Service ID
      "template_17cfpju",     // Template ID
      templateParams,
      "Xs45r19lV9h_EUOZO"     // Public Key

    )

    .then(() => {

      setStatus("Message sent successfully!");

      setFormData({
        name:"",
        email:"",
        mobile:"",
        message:"",
      });

    })


    .catch((error)=>{

      console.log("EmailJS Error:",error);

      setStatus(
        "Failed to send message. Please try again."
      );

    });

  };



  return (
    <>

    <Navbar />


    <section className="contact-hero">

      <div className="contact-hero-content">

        <h1>
          Contact Klyzen Ventures
        </h1>


        <p>
          We’d love to hear from you. Reach out to us via email,
          phone, or send us a message below.
        </p>

      </div>

    </section>




    <section className="contact-section">


      <div className="contact-wrapper">



        <div className="contact-info">


          <h2>
            Get in Touch
          </h2>


          <p>
            Email:

            <a href="mailto:info@klyzenventures.com">
              info@klyzenventures.com
            </a>

          </p>



          <p>

            Phone:

            <a href="tel:+918624968686">
              +91 8624968686
            </a>

          </p>


        </div>





        <form 
        className="contact-form"
        onSubmit={handleSubmit}
        >



          <input

          type="text"

          name="name"

          placeholder="Your Name"

          value={formData.name}

          onChange={handleChange}

          required

          />





          <input

          type="email"

          name="email"

          placeholder="Your Email"

          value={formData.email}

          onChange={handleChange}

          required

          />





          <input

          type="tel"

          name="mobile"

          placeholder="Mobile Number"

          value={formData.mobile}

          onChange={handleChange}

          />






          <textarea

          name="message"

          placeholder="Your Message"

          value={formData.message}

          onChange={handleChange}

          required

          ></textarea>





          <button type="submit">

            Send Message

          </button>




          {
            status &&

            <p className="form-status">

              {status}

            </p>
          }



        </form>



      </div>


    </section>



    <Footer />

    </>
  );
}


export default Contact;